import React, { useCallback, useContext } from 'react'
import { connect } from 'react-redux'
import { arrayOf, func, string } from 'prop-types'
import SugarcubeContext from 'apps/SugarcubeContext'

import { getIds } from 'models/favorites/selectors'

import {
    toggleFavorite as toggleFavoriteAction,
    toggleFavorites as toggleFavoritesAction,
} from 'models/favorites/actions'

import FavoriteButton from 'components/uiElements/FavoriteButton'

const FavoriteButtonContainer = ({
    favorites,
    toggleFavorite,
    localItemNumber,
    location,
    localItemNumbers,
    toggleFavorites,
    text,
}) => {
    const { isKiosk } = useContext(SugarcubeContext)
    const hasFavorites = !!(favorites && favorites.length)
    const singleFavoriteSelected = hasFavorites && localItemNumber && favorites.includes(localItemNumber)
    const multipleFavoritesSelected =
        hasFavorites &&
        localItemNumbers &&
        localItemNumbers.length &&
        localItemNumbers.every((val) => favorites.includes(val))

    const isSingleFavorite = !!localItemNumber
    const selected = isSingleFavorite ? singleFavoriteSelected : multipleFavoritesSelected

    const toggleSingle = useCallback(() => {
        const isFavorite = !selected
        const trackingInfo = {}
        if (isFavorite) {
            trackingInfo.AddedFrom = location
        } else {
            trackingInfo.RemovedFrom = location
        }
        toggleFavorite(localItemNumber, isFavorite, trackingInfo)
    }, [toggleFavorite, localItemNumber, selected])

    const toggleAll = useCallback(() => {
        const isFavorite = !selected

        // If all items are favorited or there are no favorites, we want to send all items to fav/un-favorite
        // else, we want to favorite the remaining items that are not already in favorites
        const modifyAll = selected || !hasFavorites
        const itemsToModify = modifyAll ? localItemNumbers : localItemNumbers.filter((item) => favorites.includes(item))
        if (itemsToModify && itemsToModify.length) {
            toggleFavorites(itemsToModify, isFavorite)
        }
    }, [toggleFavorites, localItemNumbers, selected])

    if (isKiosk || (!favorites && !localItemNumbers)) {
        return null
    }

    return <FavoriteButton selected={selected} onClick={isSingleFavorite ? toggleSingle : toggleAll} text={text} />
}

FavoriteButtonContainer.defaultProps = {
    favorites: null,
    localItemNumber: null,
    localItemNumbers: null,
    text: null,
}

FavoriteButtonContainer.propTypes = {
    favorites: arrayOf(string),
    toggleFavorite: func.isRequired,
    toggleFavorites: func.isRequired,
    localItemNumber: string,
    localItemNumbers: arrayOf(string),
    location: string.isRequired,
    text: string,
}

const mapStateToProps = (state) => ({
    favorites: getIds(state),
})

const mapDispatchToProps = {
    toggleFavorite: toggleFavoriteAction,
    toggleFavorites: toggleFavoritesAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteButtonContainer)
